import { call, put, takeEvery } from "redux-saga/effects";
import {
  CREATE_LEAD_NOTES,
  UPDATE_LEAD_NOTES,
  DELETE_LEAD_NOTES,
  GET_LEAD_NOTES,
  CREATE_CALL_NOTES,
  UPDATE_CALL_NOTES,
  DELETE_CALL_NOTES,
  GET_CALL_NOTES,
} from "./actionTypes";
import {
  createLeadNotesSuccess,
  createLeadNotesError,
  updateLeadNotesSuccess,
  updateLeadNotesError,
  deleteLeadNotesSuccess,
  deleteLeadNotesError,
  getLeadNotesSuccess,
  getLeadNotesError,
  createCallNotesSuccess,
  createCallNotesError,
  updateCallNotesSuccess,
  updateCallNotesError,
  deleteCallNotesSuccess,
  deleteCallNotesError,
  getCallNotesSuccess,
  getCallNotesError,
} from "./actions";
import { genericDeleteRequest, genericPostRequest, genericPutRequest, genericGetRequest } from "helpers/sf_backend_helper";
import { AppConfiguration } from "config";
import { getAuthHeaders } from "helpers/sf_utils";

function* onGetLeadNotes(action) {
  try {
    const { lead_id } = action.payload;
    const headers = getAuthHeaders();
    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/lead_notes?lead_id=${lead_id}`;
    const response = yield call(genericGetRequest, endpoint, {}, headers);
    yield put(getLeadNotesSuccess(response));
  } catch (error) {
    yield put(getLeadNotesError(error));
  }
}

function* onCreateLeadNotes(action) {
  try {
    const { lead_id, lead_note } = action.payload;
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/lead_notes?lead_id=${lead_id}`;
    const response = yield call(
      genericPostRequest,
      endpoint,
      {
        body: JSON.stringify({ lead_note: { text: lead_note.text } }),
        headers: headers,
      }
    );
        
    yield put(createLeadNotesSuccess(response));
  } catch (error) {
    yield put(createLeadNotesError(error));
  }
}

function* onUpdateLeadNotes(action) {
  try {
    const { id, lead_note } = action.payload;
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/lead_notes/${id}`;
    // genericPutRequest signature: (url, init, query_params)
    // Pass undefined for query_params since we don't need any
    const response = yield call(
      genericPutRequest,
      endpoint,
      {
        body: JSON.stringify({ lead_note }),
        headers: headers,
      },
      undefined
    );
    
    yield put(updateLeadNotesSuccess(response));
  } catch (error) {
    
    yield put(updateLeadNotesError(error));
  }
}

function* onDeleteLeadNotes(action) {
  try {
    const { id } = action.payload;

    if (!id) {
      throw new Error('Note ID is required');
    }
    
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/lead_notes/${id}`;
    const response = yield call(
      genericDeleteRequest,
      endpoint,
      {
        headers: headers,
      }
    );
    
    yield put(deleteLeadNotesSuccess({ id, ...response }));
  } catch (error) {
    yield put(deleteLeadNotesError(error));
  }
}

function* onGetCallNotes(action) {
  try {
    const { call_id } = action.payload;
    const headers = getAuthHeaders();
    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/call_notes?call_id=${call_id}`;
    const response = yield call(genericGetRequest, endpoint, {}, headers);
    yield put(getCallNotesSuccess(response));
  } catch (error) {
    yield put(getCallNotesError(error));
  }
}

function* onCreateCallNotes(action) {
  try {
    const { call_id, call_note } = action.payload;
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/call_notes?call_id=${call_id}`;
    const response = yield call(
      genericPostRequest,
      endpoint,
      {
        body: JSON.stringify({ call_note: { text: call_note.text } }),
        headers: headers,
      }
    );
        
    yield put(createCallNotesSuccess(response));
  } catch (error) {
    yield put(createCallNotesError(error));
  }
}

function* onUpdateCallNotes(action) {
  try {
    const { id, call_note } = action.payload;
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/call_notes/${id}`;
    // genericPutRequest signature: (url, init, query_params)
    // Pass undefined for query_params since we don't need any
    const response = yield call(
      genericPutRequest,
      endpoint,
      {
        body: JSON.stringify({ call_note }),
        headers: headers,
      },
      undefined
    );
    
    yield put(updateCallNotesSuccess(response));
  } catch (error) {
    
    yield put(updateCallNotesError(error));
  }
}

function* onDeleteCallNotes(action) {
  try {
    const { id } = action.payload;

    if (!id) {
      throw new Error('Note ID is required');
    }
    
    const headers = getAuthHeaders();

    const endpoint = `${AppConfiguration.BACKEND_URL}/api/v1/call_notes/${id}`;
    const response = yield call(
      genericDeleteRequest,
      endpoint,
      {
        headers: headers,
      }
    );
    
    yield put(deleteCallNotesSuccess({ id, ...response }));
  } catch (error) {
    yield put(deleteCallNotesError(error));
  }
}

function* LeadNotesSaga() {
  yield takeEvery(GET_LEAD_NOTES, onGetLeadNotes);
  yield takeEvery(CREATE_LEAD_NOTES, onCreateLeadNotes);
  yield takeEvery(UPDATE_LEAD_NOTES, onUpdateLeadNotes);
  yield takeEvery(DELETE_LEAD_NOTES, onDeleteLeadNotes);
  yield takeEvery(GET_CALL_NOTES, onGetCallNotes);
  yield takeEvery(CREATE_CALL_NOTES, onCreateCallNotes);
  yield takeEvery(UPDATE_CALL_NOTES, onUpdateCallNotes);
  yield takeEvery(DELETE_CALL_NOTES, onDeleteCallNotes);
}

export default LeadNotesSaga;
